<template>
    <div class="col-xxl-1 col-xl-1 col-lg-1 col-md-1 col-sm-1 col-2 semaforo" v-if="mostrar">
        <div class="contenedor" >
            <a-icon type="bell" @click="showDrawer" class="alerta-mobile "/>
        </div>   
        <div v-if="semaforo">
            <img src="images/semaforo.png" width="50px" alt="">
        </div>    
        <!-- <div class="contenedor1 contenedor alerta-tres" v-if="semaforo"></div>
        <div class="contenedor alerta-dos" v-if="semaforo"></div>
        <div class="contenedor alerta-uno" v-if="semaforo"></div>
        <div class="contenedor alerta-cero" v-if="semaforo"></div> -->
        <a-drawer
            placement="right"
            :body-style="{ background: '#475564', height: '100vh' }"
            :closable="false"
            :visible="visible"
            :width="300"
            :after-visible-change="afterVisibleChange"
            @close="onClose"
            >
            <div class="text-center encabezado">
                <img src="images/LOGO.png" width="100%" alt="">
                <a-icon type="warning" theme="twoTone" two-tone-color="#B0261B" />
                <p class="mt-5 p-5 text-white">{{ tituloAlerta }}</p>
            </div>            
            <div class="text-center p-5">
                <div v-if="alertas.length > 0">
                    <ul>
                        <li></li>
                    </ul>
                </div>
                <div v-else>
                    <a-alert message="No hay alertas que mostrar" type="info" />
                </div>
            </div>    
            <div class="text-center position-absolute bottom-0 end-0">
                <img src="images/logo_software.png" width="70%" alt="">
            </div>
        </a-drawer>
    </div>
</template>
<script>
    export default {
        props: ['tituloAlerta', 'mostrar', 'semaforo'],
        data() {
            return {      
                alertas: [],   
                visible: false
            }
        },
        methods: {
            afterVisibleChange(val) {
                console.log('visible', val);
            },
            showDrawer() {
                this.visible = true;
            },
            onClose() {
                this.visible = false;
            },
        },
    }
</script>
<style scoped>
    .alerta-cero{
        background: linear-gradient(#6495ED, #311663 80%);
    }
    .alerta-uno{
        background: linear-gradient(#efec27, #00b431 80%);
    }
    .alerta-dos{
        background: linear-gradient(#ef5727, #efec27 80%);
    }
    .alerta-tres{
        background: #DC143C;
    }
    .alerta-mobile{
        display: none;
    }
    .anticon-bell{
        font-size: 25px;
        margin-top: 20px;
        margin-right: 10%;
    }
    .contenedor {
        /* border: 1px solid #000;       */                
        height: 10%;
        width: 20%;
    }
    
    .contenedor1{    
        margin: calc((100vh - 450px) /2) 0px 0px 0px;
    }
    
    @media screen and (max-width: 992px){
        .alerta-mobile{
            display: block;
        }
    }
</style>